module.exports = __webpack_public_path__ + "img/map-tesislerEN.8b71bc67.svg";